import { quickFeed } from "@/mocks/gua";

const tagStyle: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热议: "bg-secondary-500 text-background-50",
  新瓜: "bg-accent-500 text-background-50",
  进行中: "bg-background-200 text-foreground-700",
};

export default function QuickFeed() {
  return (
    <section id="feed" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日瓜点速报<span className="text-secondary-500"> · 跟着更新走</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              高频滚动更新的短讯流，带时间标记，先扫一眼今天都有哪些新鲜事。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600">
            <i className="ri-time-line text-accent-600" aria-hidden="true"></i>
            数据截至 09-05 09:40
          </span>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          {quickFeed.map((item, idx) => (
            <div
              key={item.id}
              className="grid items-center gap-3 rounded-xl border border-background-200 bg-background-100/50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50 sm:grid-cols-[120px_1fr_auto] md:p-5"
            >
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span
                  className={
                    "flex h-7 w-7 items-center justify-center rounded-lg text-xs font-bold " +
                    (idx < 2 ? "bg-secondary-500 text-background-50" : "bg-background-200 text-foreground-700")
                  }
                >
                  {idx + 1}
                </span>
                <span className="whitespace-nowrap">{item.time}</span>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap text-xs font-medium text-accent-700">{item.cat}</span>
                  <a href="#timeline" className="truncate text-base font-semibold text-foreground-900 transition-colors hover:text-primary-600">
                    {item.title}
                  </a>
                </div>
                <p className="mt-1 hidden truncate text-sm text-foreground-600 md:block">{item.summary}</p>
              </div>
              <div className="flex shrink-0 items-center justify-end gap-2">
                <span className={"inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium " + (tagStyle[item.tag] ?? "bg-background-200 text-foreground-700")}>
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {item.tag} {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}